import React, { useEffect, useRef } from 'react';
import ErrorInfo from './ErrorInfo';
import { SIGN_IN_WITH_WORKSPACE } from '../../constants';
import AntButton from '../prescriptionPad/rightPanel/workspace/padV2/AntButton';
interface NumberInputProps {
    mobileNumber: string;
    numberError: boolean;
    loading: boolean;
    maxTryError: string;
    handleOnInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    handleOnSubmit: () => void;
}

export const validateEmail = (email: string): boolean => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email.trim());
};

const NumberInput: React.FC<NumberInputProps> = ({
    mobileNumber,
    numberError,
    loading,
    maxTryError,
    handleOnInputChange,
    handleOnSubmit,
}) => {
    const mobileNumberRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        if (mobileNumberRef.current) {
            mobileNumberRef.current.select();
        }
    }, []);

    return (
        <>
            <div className="px-16 py-8 text-center font-600 text-neutral-3">
                Let&#x27;s Get Started{' '}
            </div>
            <div className="mb-24">
                {/* <div
                    className={
                        numberError
                            ? 'ether-input-component border border-status-error focus-within:border-status-error'
                            : 'ether-input-component border border-neutral-5  focus-within:border-actionPrimary-active'
                    }
                >
                    <div className="flex items-center w-full">
                        <div
                            className={
                                numberError
                                    ? 'relative flex z-0 w-full text-status-error'
                                    : 'relative flex z-0 w-full text-neutral-5 focus-within:text-actionPrimary-active'
                            }
                        >
                            <input
                                ref={mobileNumberRef}
                                placeholder="Mobile Number / Email"
                                defaultValue={mobileNumber}
                                onChange={handleOnInputChange}
                            />
                            <label>Mobile Number / Email</label>
                        </div>
                    </div>
                    <div className="relative top-2">
                        {loading ? (
                            <Loader />
                        ) : numberError ? (
                            <NumberErrorSvg />
                        ) : validateMobileNumber(mobileNumber.trim()) ||
                          validateEmail(mobileNumber) ? (
                            <SubmitButton handleSubmit={handleOnSubmit} disabled={false} />
                        ) : null}
                    </div>
                </div> */}
                <div className="flex items-center justify-between">
                    <AntButton
                        onClick={() => (window.location.href = SIGN_IN_WITH_WORKSPACE)}
                        type="primary"
                        className="w-full mr-16"
                    >
                        Login
                    </AntButton>
                    <span>or</span>
                    <AntButton
                        onClick={() => (window.location.href = SIGN_IN_WITH_WORKSPACE)}
                        type="secondary"
                        className="w-full ml-16"
                    >
                        Create Account
                    </AntButton>
                </div>
            </div>
            {!!maxTryError || numberError ? <ErrorInfo message={maxTryError} /> : null}
        </>
    );
};

export default NumberInput;
